import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

export interface RatePullingModalThemeProps {
  attemptNumber: number;
  validatedProgressDone: string | number;
}
const styles: ComponentStylesProps<RatePullingModalThemeProps> = {
  modal: { textAlign: 'center', padding: '4rem 2.4rem', maxWidth: '65.6rem', minHeight: '22rem' },
  icon: ({ attemptNumber }) => ({
    marginBottom: attemptNumber > -1 ? '1.6rem' : '2.6rem',
    color: attemptNumber > -1 ? colors.orange[600] : colors.green[600],
  }),
  title: {
    textAlign: 'center',
    font: { size: '2.4rem', lineHeight: '3.2rem', weight: 700 },
    letterSpacing: '0.02rem',
    color: colors.neutral[900],
    margin: '0 0 2.6rem',
    borderRadius: '1rem',
  },
  completeStatus: {
    font: { size: '1.6rem', lineHeight: '2.8rem' },
    color: colors.blue[600],
  },
  modalFooter: {
    display: 'flex',
    padding: '0 13%',
    justifyContent: 'space-between',
  },
  progress: {
    backgroundColor: colors.neutral[200],
    borderRadius: '1rem',
    position: 'relative',
    margin: '1rem auto',
    height: '2rem',
    width: '30rem',
  },

  progressDone: ({ validatedProgressDone }) => ({
    background: colors.blue[600],
    borderRadius: '1rem',
    height: '100%',
    width: validatedProgressDone,
    transition: '1s ease 0.3s',
  }),
};

const createStyles = createUseStyles(styles);

export { createStyles };
